// 首页信息块，标题组件
<template>
	<div class="my-title">
		<span class="title">{{ title }}</span>
		<div class="split"></div>
		<span class="more" @click="handleMoreClick">more</span>
	</div>
</template>

<script>
export default {
	name: 'my-title',
	data() {
		return {}
	},
	props: {
		title: {
			type: String,
			default: '',
		},
	},
  methods:{
    handleMoreClick(){
      this.$emit('handleMoreClick')
    }
  }
}
</script>

<style lang="less" scoped>
.my-title {
	width: 100%;
  height: 22px;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	.title {
		color: #01449B;
		font-weight: bolder;
		font-size: 20px;
	}
	.split {
		flex-grow: 1;
		border-bottom: 1px #e0d7d7 solid;
		height: 0;
		margin: 0 7px 0 23px;
	}
	.more {
		cursor: pointer;
		font-size: 12px;
		color: #E75619;
	}
}
</style>
